module.exports = __webpack_public_path__ + "img/card_2.4f9a9787.png";